import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ComputerLab = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);
    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">COMPUTER LAB</h1>


            <div className="w-full " data-aos="fade-up">
                <p className="text-lg  text-gray-700 leading-relaxed">
                    The Computer Lab is a hub of digital learning, equipped with modern systems and high-speed internet. It provides students with hands-on experience in coding, programming, and various software applications. Our lab fosters technological skills, creativity, and problem-solving abilities, preparing students for the digital world. With a focus on practical learning, we ensure a dynamic and interactive environment for all learners.
                </p>


            </div>


            {/* Image Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-aos="fade-up">
                <img src="https://img.freepik.com/free-vector/students-working-computer-room_1308-30865.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 1" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/students-working-computer-room_1308-30865.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 2" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/students-working-computer-room_1308-30865.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 3" className="w-full h-48 object-cover rounded-lg shadow-md" />
                <img src="https://img.freepik.com/free-vector/students-working-computer-room_1308-30865.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Smart Classroom 4" className="w-full h-48 object-cover rounded-lg shadow-md" />
            </div>
        </div>
    );
}

export default ComputerLab;





